import React, { useState } from 'react';
import { Bars3Icon, ShieldIcon } from '@heroicons/react/24/outline';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const Header = () => {

   const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className="bg-white shadow-sm border-b border-border sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center" >
            <img className="w-18 h-16 text-primary mr-9" src="images/logotmw.png" onClick={() => navigate('/')}/>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="text-text-secondary hover:text-primary transition-colors"
            >
              How It Works
            </button>
            <button 
              onClick={() => scrollToSection('pricing')}
              className="text-text-secondary hover:text-primary transition-colors"
            >
              Pricing
            </button>
            <button 
              onClick={() => scrollToSection('success-stories')}
              className="text-text-secondary hover:text-primary transition-colors"
            >
              Success Stories
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-text-secondary hover:text-primary transition-colors"
            >
              FAQ
            </button>
            <button onClick={() => navigate('/login-registration-page')} className="btn-primary">Get Started</button>
          </div>
          
          <button 
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <Bars3Icon className="w-6 h-6" />
          </button>
        </div>
      </div>
      
      {mobileMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-border">
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="block px-3 py-2 text-text-secondary hover:text-primary transition-colors"
            >
              How It Works
            </button>
            <button 
              onClick={() => scrollToSection('pricing')}
              className="block px-3 py-2 text-text-secondary hover:text-primary transition-colors"
            >
              Pricing
            </button>
            <button 
              onClick={() => scrollToSection('success-stories')}
              className="block px-3 py-2 text-text-secondary hover:text-primary transition-colors"
            >
              Success Stories
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="block px-3 py-2 text-text-secondary hover:text-primary transition-colors"
            >
              FAQ
            </button>
            <button onClick={() => navigate('/login-registration-page')} className="btn-primary w-full mt-2">Get Started</button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;